import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { Row } from 'reactstrap';
import { decryptData } from '../../../utils/helper';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { failed } from '../../../utils/Tostify';
import Loader from '../../../components/Loader/Loader';
import { getApplicationActivity } from '../../../api/Applications';
import { platformLayout } from '../../../utils/constants';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { ITEMS_PER_PAGE } from '../../../utils/constants';
import { stageStatusOption } from '../Constant';

const ApplicationActivity = ({application, activeTab}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  let role = localStorage.getItem("userRole");
  const [isLoading, setIsLoading] = useState(false);
  const [activity, setActivity] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);


  const getActivity = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getApplicationActivity({dispatch, token, type : "Application", applicationId : application?._id, clinicId : role !== platformLayout?.Patient ? localStorage.getItem("currentHospitalId") : application?.patientData?.currentClinic});
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setActivity(responseData);
        setIsLoading(false);
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  // Trigger the API call when the "Activity" tab (tabId 8) is clicked
  useEffect(() => {
    if (activeTab === "8" && application?._id) {
      getActivity();
    }
  }, [activeTab, application?._id]);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedActivity = activity?.slice(startIndex, endIndex);

    const handlePagination = (page) => {
      setCurrentPage(page);
    };

  return (
    <Fragment>
        {isLoading ? <Loader/> : null}
        <div className="data_patient">
        <div className="application_details_block mt-3 mb-3">
        {role !== platformLayout?.Patient && <Row>
        <h3 className="title_name mt-0">Application Overview</h3>
          <div className="col-xl-4 col-lg-4 application_details">
                <div className="row">
                  <div className="col-3 text-end"><p>Start Date</p></div>
                  <div className="col-1 text-center"><p>:</p></div>
                  <div className="col-8"><p>{moment(application?.createdAt).format("MMM-DD-YYYY")}</p></div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 application_details">
              <div className="row">
                <div className="col-4 text-end"><p>Application Type</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7"><p>{application?.applicationType?.applicationTitle}</p></div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 application_details">
              <div className="row">
                <div className="col-4 text-end"><p>Application Status</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7"><p>{stageStatusOption.find(option => option.value === application?.status)?.label || '-'}</p></div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 application_details">
              <div className="row">
                <div className="col-3 text-end"><p>Active Days</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7">
                  <p>
                    {moment().diff(moment(application?.createdAt), "days") + " Days"}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 application_details">
              <div className="row">
                <div className="col-4 text-end"><p>Consultant</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7">
                  <p>
                    {application.consultantUser?.[0]
                      ? `${application.consultantUser?.[0]?.firstName} ${application.consultantUser?.[0]?.lastName}`
                      : "No Consultant assigned."}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 application_details">
              <div className="row">
                <div className="col-4 text-end"><p>Application Id</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7"><p>{application?.applicationID}</p></div>
              </div>
            </div>
            </Row>}
            <Row className="mt-3 align-items-center">
            <h3 className="title_name mt-1">Primary Applicant</h3>

            <div className="col-xl-4 col-lg-6 application_details">
              <div className="row">
                <div className="col-3 text-end"><p>Name</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7">
                  <p>
                    {decryptData(application?.patientData?.name[0].text)}{" "}
                    <button
                      className="add_notes"
                      onClick={() =>
                        navigate("/clinic/patient-profile", {
                          state: { patientData: application?.patientData?._id, isEditMode: true}
                        })
                      }
                    >
                      View Details
                    </button>
                  </p>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-3 text-end"><p>Email ID</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7">
                  <p>
                    {decryptData(
                      application?.patientData?.telecom.find((obj) => obj?.system === "email")
                        ?.value || "-"
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 application_details">
              <div className="row">
                <div className="col-4 text-end"><p>Gender</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7">
                  <p>{decryptData(application?.patientData?.gender) || "-"}</p>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-4 text-end"><p>Status</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7">
                  <p>{decryptData(application?.patientData?.maritalStatus) || "-"}</p>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 application_details">
              <div className="row">
                <div className="col-4 text-end"><p>DOB</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7">
                  <p>{decryptData(application?.patientData?.birthDate) || "-"}</p>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-4 text-end"><p>State</p></div>
                <div className="col-1 text-center"><p>:</p></div>
                <div className="col-7">
                  <p>
                  {application.patientData?.address[0].state && decryptData(application.patientData?.address[0].state)}
                  </p>
                </div>
              </div>
            </div>
          </Row>
        </div>
        <h6 className="form_name list_blk">Activity: </h6>
        <div className="table_space table_listing_color">
        <div className="table-responsive">
            <table>
            <thead>
            <tr className="header_table">
                <th></th>
                <th>Time</th>
                <th>User</th>
                <th>Activity</th>
            </tr>
            </thead>
            <tbody>
            {paginatedActivity?.length > 0 ? (
                paginatedActivity?.map((obj, index) => (
                <>
                    <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                        <td>{index + 1 }</td>
                        <td>{moment(obj?.createdAt).format("MMM-DD-YYYY, h:mm A")}</td>
                        <td>{obj?.userId?.firstName + " " + obj?.userId?.lastName}</td>
                        <td>{obj?.details}</td>
                    </tr>
                </>
                ))
            ) : (
                <tr>
                <td colSpan={10}>
                    <p className="text-center">No Data Found</p>
                </td>
                </tr>
            )}
            </tbody>
            </table>
        </div>
        </div>
        <div className='d-flex justify-content-center'>
          <CustomPagination
            totalPages={Math.ceil(activity?.length / ITEMS_PER_PAGE)}
            totalRows={activity?.length}
            rowsPerPage={ITEMS_PER_PAGE}
            page={currentPage}
            handlePage={handlePagination}
          />
        </div>
        </div>
    </Fragment>
  );
};

export default ApplicationActivity;
